module.exports = {


    /**
     * Keyword all event namespaces should be threaded to
     */
    CUSTOM_EVENT_NAMESPACE_KEYWORD: 'find'
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/constant/events.js
// module id = 428
// module chunks = 36